<template>
  <router-view></router-view>
  <Modal :id="store.activeMoment.urlSegment" @close-modal="store.onCloseModal">
    <template #content>
      <div v-if="store.activeMoment.isLoading"><component :is="spinnerComponent" /></div>
      <div v-else v-html="store.activeMoment.modalContent"></div>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { useTimelineMapService } from "@features/Pages/TimelineMapPage/_js/app/services/timelineMapService";
import {computed, onMounted} from "vue";
import { useDragScroll } from "./services/jvm/dragscroll";
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";
import Modal from "@features/Pages/TimelineMapPage/_js/app/components/modal/Modal.vue";
import SpinnerJvm from '@shared/spinner/spinner-jvm.vue';
import SpinnerMm from '@shared/spinner/spinner-mm.vue';
import SpinnerVrak from '@shared/spinner/spinner-vrak.vue';

const store = useTimelineMapStore();
const { 
  registerScrollListener,
  scrollToMoment,
  registerParallax,
  getHostname,
  getShowMap,
  getShowMomentsList,
  getTimelineMapData,
  getMapboxConfig,
  getTranslations,
  getModalContent 
} = useTimelineMapService();

const spinnerComponent = computed(() => {
  const mapping = {
    jvm: SpinnerJvm,
    mm: SpinnerMm,
    vrak: SpinnerVrak,
  };

  if (store.isJVM) return mapping.jvm;
  if (store.isMM) return mapping.mm;
  if (store.isVRAK) return mapping.vrak;

  return SpinnerMm;
});

onMounted(() => {
  getHostname();
  getShowMap();
  getShowMomentsList();
  getTimelineMapData();
  getTranslations();
  getModalContent();

  if (store.isJVM || store.isMM) {
    useDragScroll('timeline');
    registerScrollListener();
    scrollToMoment();
    registerParallax();
  }
  
  if (store.isVRAK) {
    getMapboxConfig();
  }
});
</script>
